<button class="btn btn-primary mb-1" [disabled]="!isEnabled || !hasPermission || isBlocked" (click)="openBlockedCategoriesModal()" #button>
    <span class="element-text">{{ 'console.block-categories' | translate }}</span>
</button>

